import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import isEmpty from '../../../../utils/objectchecking/IsEmpty';
import { Dialog } from '@material-ui/core';
import { sendHasSeenMessage } from '../../../../stores/websocketStore/utils/outgoingMessages/msgcenter/sendHasSeenMessage';

const useStyles = makeStyles((theme) => ({
  root: {
    spacing: theme.spacing(10),
    border: '1px solid',
  },
  paper: {
    width: '25%',
  },
}));

export default function ProductUpdates({ msgs }) {
  const classes = useStyles();
  const [seeProductUpdates, setSeeProductUpdates] = useState(false);
  const [unseenMsgs, setUnseenMsgs] = useState(false);
  const [userAcknowledged, setUserAcknowledged] = useState(false);
  useEffect(() => {
    setUnseenMsgs(msgs !== undefined && msgs.length > 0);
  }, [msgs]);
  //console.log(msgs);
  //console.log(msgs.length);
  return (
    <>
      <Dialog
        open={unseenMsgs && !userAcknowledged}
        onClose={() => setUserAcknowledged(true)}
      >
        There are unseen product updates! Please select settings on the toolbar
        and delete them after you have seen them.
      </Dialog>
      <ListItem onClick={() => setSeeProductUpdates(!seeProductUpdates)}>
        Product Updates
        {msgs !== undefined && msgs.length > 0 ? (
          <Typography style={{ color: 'red' }}>({msgs.length})</Typography>
        ) : null}
      </ListItem>
      <Drawer
        anchor="right"
        open={seeProductUpdates}
        onClose={() => {
          setSeeProductUpdates(false);
        }}
        classes={{ paper: classes.paper }}
      >
        <ProductUpdatesDrawer msgs={msgs} />
      </Drawer>
    </>
  );
}

function ProductUpdatesDrawer({ msgs }) {
  //let key = 0;
  // return (
  // <div
  // dangerouslySetInnerHTML={{ __html: "<html>First &middot; Second</html>" }}
  ///>
  //);
  if (msgs === undefined || isEmpty(msgs)) {
    return null;
  }
  return (
    <List>
      {msgs.map((msg) => {
        //console.log(msg);
        return <BuildMsgItem key={msg.key} html={msg.html} msgKey={msg.key} />;
        //return <div dangerouslySetInnerHTML={{ __html: msg.html }} />;
      })}
    </List>
  );
}

function BuildMsgItem({ html, msgKey }) {
  const [showMore, setShowMore] = useState(false);
  const [maxHeight, setMaxHeight] = useState(15);
  return (
    <>
      <ListItem>
        <ListItemIcon
          onClick={() => {
            sendHasSeenMessage(msgKey);
          }}
        >
          <DeleteIcon />
        </ListItemIcon>
        <ListItemText
          //inset
          //primaryTypographyProps={{ fontSize: 10 }}
          primary={
            <div
              style={{
                fontSize: 10,
                maxHeight: maxHeight,
                textOverflow: 'ellipsis',
                overflowX: 'hidden',
                overflowY: 'hidden',
              }}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          }
        />
        <ListItemIcon
          onClick={() => {
            setMaxHeight(showMore ? 15 : 10000);
            setShowMore(!showMore);
          }}
        >
          {showMore ? <ExpandLess /> : <ExpandMore />}
        </ListItemIcon>
      </ListItem>
      <Divider />
    </>
  );
}
